import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuItems = [
    { label: 'Accueil', href: '/' },
    { label: 'Services', href: '/#services' },
    { label: 'Tarifs', href: '/pricing' },
    { label: 'Blog', href: '/blog' },
    { label: 'Contact', href: '/#contact' }
  ];

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
      <nav className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center cursor-pointer">
            <span className="text-3xl font-bold text-teal-600" style={{ fontFamily: '"Pacifico", serif' }}>
              Ecomez
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a href="/#services" className="text-gray-700 hover:text-teal-600 transition-colors duration-300 font-medium cursor-pointer">
              Services
            </a>
            <a href="/#why-us" className="text-gray-700 hover:text-teal-600 transition-colors duration-300 font-medium cursor-pointer">
              Pourquoi Nous
            </a>
            <Link to="/pricing" className="text-gray-700 hover:text-teal-600 transition-colors duration-300 font-medium cursor-pointer">
              Tarifs
            </Link>
            <a href="/#areas" className="text-gray-700 hover:text-teal-600 transition-colors duration-300 font-medium cursor-pointer">
              Zones
            </a>
            <Link to="/blog" className="text-gray-700 hover:text-teal-600 transition-colors duration-300 font-medium cursor-pointer">
              Blog
            </Link>
            <a href="/#contact" className="text-gray-700 hover:text-teal-600 transition-colors duration-300 font-medium cursor-pointer">
              Contact
            </a>
            <a
              href="/#reservation"
              className="bg-teal-600 text-white px-6 py-2 rounded-full hover:bg-teal-700 transition-all duration-300 font-semibold cursor-pointer whitespace-nowrap"
            >
              Réserver
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-gray-700 cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`text-2xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-3">
            <a href="/#services" onClick={() => setIsMenuOpen(false)} className="block w-full text-left text-gray-700 hover:text-teal-600 transition-colors py-2 cursor-pointer">
              Services
            </a>
            <a href="/#why-us" onClick={() => setIsMenuOpen(false)} className="block w-full text-left text-gray-700 hover:text-teal-600 transition-colors py-2 cursor-pointer">
              Pourquoi Nous
            </a>
            <Link to="/pricing" onClick={() => setIsMenuOpen(false)} className="block w-full text-left text-gray-700 hover:text-teal-600 transition-colors py-2 cursor-pointer">
              Tarifs
            </Link>
            <a href="/#areas" onClick={() => setIsMenuOpen(false)} className="block w-full text-left text-gray-700 hover:text-teal-600 transition-colors py-2 cursor-pointer">
              Zones
            </a>
            <Link to="/blog" onClick={() => setIsMenuOpen(false)} className="block w-full text-left text-gray-700 hover:text-teal-600 transition-colors py-2 cursor-pointer">
              Blog
            </Link>
            <a href="/#contact" onClick={() => setIsMenuOpen(false)} className="block w-full text-left text-gray-700 hover:text-teal-600 transition-colors py-2 cursor-pointer">
              Contact
            </a>
            <a 
              href="/#reservation"
              onClick={() => setIsMenuOpen(false)}
              className="block w-full bg-teal-600 text-white px-6 py-2 rounded-full hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap text-center"
            >
              Réserver
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}
